import { CodeableConcept } from 'src/careflow/ph-core/fhir-client/resources';

export const INTERNAL_REFERRAL_CATEGORIES = [
  'intake-referral',
  'inbound-referral', 
  'outbound-referral',
  'outbound_referral',
  'outbound_referral_child',
  'internal-referral',
  'external-referral',
  'internal',
  'referral',
  'doctors',
  'Internal',
  'Referral',
  'Doctors'
];

/**
 * Determines if a category is internal (system-generated) or user-selected
 * @param category - The category to check
 * @returns true if the category is internal, false otherwise
 */
export const isInternalCategory = (category: CodeableConcept | any): boolean => {
  if (!category) return false;
  
  const categoryCode = category.coding?.[0]?.code || category.code || category.display;
  if (!categoryCode) return false;
  
  return INTERNAL_REFERRAL_CATEGORIES.some(internalCode => 
    internalCode.toLowerCase() === categoryCode.toLowerCase()
  );
};

/**
 * Gets the appropriate styling for a category chip based on whether it's internal or user-selected
 * @param category - The category to style
 * @returns MUI sx props for styling the chip
 */
export const getCategoryChipStyle = (category: CodeableConcept | any) => {
  const isInternal = isInternalCategory(category);
  
  return {
    m: 0.2, 
    textTransform: 'capitalize' as const,
    ...(isInternal ? {
      backgroundColor: '#EEEFF0',
      color: '#212B36',
    } : {
      backgroundColor: '#e3f2fd',
      color: '#1565c0', 
      // border: '1px solid #42a5f5'
    })
  };
};

/**
 * Filters out internal categories from a list of categories for editing purposes
 * @param categories - Array of categories to filter
 * @returns Array of categories with internal ones removed
 */
export const filterOutInternalCategories = (categories: any[]): any[] => {
  if (!categories) return [];
  return categories.filter(category => !isInternalCategory(category));
};

/**
 * Separates categories into internal and user-selected arrays
 * @param categories - Array of categories to separate
 * @returns Object containing internal and user categories
 */
export const separateCategories = (categories: any[]) => {
  if (!categories) return { internal: [], user: [] };
  
  const internal = categories.filter(category => isInternalCategory(category));
  const user = categories.filter(category => !isInternalCategory(category));
  
  return { internal, user };
}; 